import React from 'react'
import {State} from '../types'
import {DetailsPageRuntimeContext} from '../components/runtime-context/context'

export function usePageStateSelector<T>(selector: (state: State) => T): T {
  return selector(React.useContext(DetailsPageRuntimeContext).state)
}

export const usePageActions = () => React.useContext(DetailsPageRuntimeContext).actions
